var exports = {
  "JC": "Accordion.module__accordion___N1hVU2",
  "U1": "Accordion.module__headerRow___N1hVU2",
  "L9": "Accordion.module__headerClickTarget___N1hVU2",
  "N4": "Accordion.module__titleButton___N1hVU2",
  "Z2": "Accordion.module__descriptionButton___N1hVU2",
  "me": "Accordion.module__caretButton___N1hVU2",
  "VW": "Accordion.module__headerContent___N1hVU2",
  "$": "Accordion.module__titleRow___N1hVU2",
  "QE": "Accordion.module__headerAction___N1hVU2",
  "ID": "Accordion.module__compactTitle___N1hVU2",
  "SY": "Accordion.module__compactDescription___N1hVU2",
  "OW": "Accordion.module__caret___N1hVU2",
  "bd": "Accordion.module__caretExpanded___N1hVU2",
  "FG": "Accordion.module__contentWrapper___N1hVU2",
  "Qs": "Accordion.module__content___N1hVU2",
};

module.exports = exports;
